import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function BlogTeaser() {
  const posts = [{
    title: 'The State of AI Adoption in African Enterprises — 2026',
    excerpt: 'How leading African businesses are leveraging AI to compete globally and drive unprecedented growth.',
    date: 'Feb 15, 2026',
    category: 'Research'
  }, {
    title: 'Generative AI: Beyond the Hype',
    excerpt: 'Practical applications of generative AI for enterprise operations, focusing on measurable ROI.',
    date: 'Jan 28, 2026',
    category: 'Technology'
  }, {
    title: 'Building AI-Ready Organizations',
    excerpt: 'A strategic framework for enterprise AI transformation, from data infrastructure to cultural shifts.',
    date: 'Jan 10, 2026',
    category: 'Strategy'
  }];
  return <section className="py-24 bg-brand-black relative" data-id="element-31">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-32">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6" data-id="element-33">
          <div className="max-w-2xl" data-id="element-34">
            <div className="inline-flex items-center gap-2 mb-4" data-id="element-35">
              <div className="w-8 h-1 bg-brand-primary rounded-full" data-id="element-36"></div>
              <h2 className="text-brand-primary font-semibold uppercase tracking-wider text-sm" data-id="element-37">
                Latest Insights
              </h2>
            </div>
            <h3 className="text-3xl md:text-5xl font-bold text-white" data-id="element-38">
              Thoughts on the Future of AI
            </h3>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-39">
          {posts.map((post, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="group cursor-pointer" data-id="element-40">
              {/* Image Placeholder */}
              <div className="w-full h-56 rounded-2xl bg-gradient-to-br from-[#1a1718] via-brand-black to-brand-dark/30 relative overflow-hidden mb-6 border border-white/5 group-hover:border-brand-primary/30 transition-colors duration-300" data-id="element-41">
                <div className="absolute inset-0 grid-pattern opacity-30 group-hover:scale-110 transition-transform duration-700" data-id="element-42"></div>
                <div className="absolute top-4 left-4 glass-card px-3 py-1 rounded-full text-xs font-semibold text-white tracking-wider" data-id="element-43">
                  {post.category}
                </div>
              </div>

              <div data-id="element-44">
                <div className="text-brand-primary text-sm font-medium mb-2" data-id="element-45">
                  {post.date}
                </div>
                <h4 className="text-xl font-bold text-white mb-3 group-hover:text-brand-light transition-colors line-clamp-2" data-id="element-46">
                  {post.title}
                </h4>
                <p className="text-gray-400 mb-4 line-clamp-2" data-id="element-47">
                  {post.excerpt}
                </p>
                <div className="flex items-center gap-2 text-white font-medium group-hover:text-brand-primary transition-colors" data-id="element-48">
                  Read Article
                  <ArrowRightIcon className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-49" />
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}